import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FORM_MSGS } from 'src/app/_common/product-config';

@Component({
  selector: 'app-data-lost-warning-modal',
  templateUrl: './data-lost-warning-modal.component.html',
  styleUrls: ['./data-lost-warning-modal.component.scss']
})
export class DataLostWarningModalComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  private formMsgs = FORM_MSGS; //Using it in HTML

  ngOnInit() {
  }

}
